import { render, staticRenderFns } from "./mmEditor.vue?vue&type=template&id=5d2a3ae4"
import script from "./mmEditor.vue?vue&type=script&lang=js"
export * from "./mmEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports